import React from 'react';
import { Input } from '@windmill/react-ui';
const RadioButton = ({register, name,value1,value2,label,selectedValue,handleChange,
  label1 = value1, // Default to value1 if label1 is not provided
  label2 = value2, // Default to value2 if label2 is not provided
 }) => {
  const id1 = `${name}_first`;
const id2 = `${name}_second`;
const styles=`  
    .radio-label {
      padding-left: 10px;
      margin-right: 10px;
      color: #333;
    }
    .form-radio:focus{
      outline:none;
    }`;
    return (
<>
<style>{styles}</style>
<Input {...register(`${name}`)}
      type="radio"
      name={name} 
      value={value1}
      id={id1}
      className="radio-input"
      onChange={() => handleChange(value1)}
      checked={selectedValue === value1}
    />
    <label htmlFor={id1} className="radio-label">{label1}</label>
   <Input
    {...register(`${name}`)}
      type="radio"
      name={name} 
      value={value2}
      id={id2}
      className="radio-input"
      checked={selectedValue === value2}
      onChange={() => handleChange(value2)}
    />
     <label htmlFor={id2} className="radio-label">{label2}</label>

</>
);
};

export default RadioButton;